import { registerLegacySalvoLiteComponent, log } from '@eastsideco/salvo-ts';
import axios from 'axios';

class ShowMore {
    constructor(theme, elem) {
        this._theme = theme;
        this._name = this.constructor.name;
        this._elem = elem;
        this._text = elem.getAttribute('data-text');
        this._loadingText = elem.getAttribute('data-loading-text');
        this._itemContainerSelector = elem.getAttribute('data-item-container-selector');
        this._direction = elem.getAttribute('data-direction');
        this._itemSelector = elem.getAttribute('data-item-selector');
        this._paginationWrapper = elem;
    }

    onInit() {
        // Update text content
        this._elem.innerHTML = this._text;

        // Listen for clicks
        this._elem.addEventListener('click', () => {

            // Set loading text
            this._elem.innerHTML = this._loadingText;

            // Get scroll-y value
            let scroll = parseInt(window.scrollY, 10);

            // Load more/previous
            if (this._direction == 'previous') {
                this.loadPrevious(scroll);
            } else {
                this.loadMore(scroll);
            }
        });
    }

    loadMore(scroll) {

        // Prepare variables
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const nextUrl = this._elem.getAttribute('data-next-page');

        // Make request for the next page
        axios.get(nextUrl).then((response) => {

            // Get new elements from response data and add them to a new elements wrapper
            const newElementsWrapper = document.createElement('div');
            newElementsWrapper.innerHTML = response.data;

            // Update pagination results
            const newResults = newElementsWrapper.querySelector('.load-more__results');
            self.updatePaginationResults(newResults);

            // Update next page url
            const newMoreButton = newElementsWrapper.querySelector('[data-show-more]');
            self.updateNextPageUrl(newMoreButton);

            // Add new elements to page
            // eslint-disable-next-line no-underscore-dangle
            const newElements = newElementsWrapper.querySelectorAll(self._itemSelector);
            self.addNewElements(newElements, nextUrl, scroll);

            // Update page query string in URL
            const url = new URL(window.location);
            const currentPage = Number(nextUrl.split('?page=')[1]);
            url.searchParams.set('page', currentPage);
            window.history.pushState(null, '', url.toString());

        }).catch((e) => {
            log.error('Pagination', `Error requesting next page`, { e });
        });
    }

    loadPrevious(scroll) {

        // Prepare variables
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const previousUrl = this._elem.getAttribute('data-previous-page');

        // Make request for the next page
        axios.get(previousUrl).then((response) => {

            // Get new elements from response data and add them to a new elements wrapper
            const newElementsWrapper = document.createElement('div');
            newElementsWrapper.innerHTML = response.data;

            // Update next page url
            const newPreviousButton = newElementsWrapper.querySelector('[data-show-more]');
            self.updatePreviousPageUrl(newPreviousButton);

            // If there is a load more button
            // update pagination results
            const newResults = newElementsWrapper.querySelector('.load-more__results');
            self.updatePaginationResults(newResults);

            // Add new elements to page
            // eslint-disable-next-line no-underscore-dangle
            const newElements = [...newElementsWrapper.querySelectorAll(self._itemSelector)].reverse();
            self.addNewElements(newElements, previousUrl, scroll, 'previous');

            // Update page query string in URL
            const url = new URL(window.location);
            const currentPage = Number(previousUrl.split('?page=')[1]) || 0;
            url.searchParams.set('page', currentPage);
            window.history.pushState(null, '', url.toString());

        }).catch((e) => {
            log.error('Pagination', `Error requesting next page`, { e });
        });
    }

    updatePaginationResults(newResults) {
        const oldResults = document.querySelector('.load-more__results');

        if (this._direction == 'previous') {
            const oldPagination = oldResults.querySelector('.end');
            const newPagination = newResults.querySelector('.end');
            newPagination.innerHTML = oldPagination.innerHTML;
        } else {
            const oldPagination = oldResults.querySelector('.start');
            const newPagination = newResults.querySelector('.start');
            newPagination.innerHTML = oldPagination.innerHTML;
        }
        
        if (newResults && oldResults) {
            oldResults.parentNode.replaceChild(newResults, oldResults);
        }
    }

    updateNextPageUrl(nextButton) {

        // Check that the button exists
        if (nextButton) {

            // Update pagination URL attribute
            const newNextPage = nextButton.getAttribute('data-next-page');
            const oldMoreButton = document.querySelector('[data-show-more]');
            oldMoreButton.setAttribute('data-next-page', newNextPage);

        // Button doesn't exist, no more items to load
        } else {

            // Remove pagination
            this._paginationWrapper.remove();
        }
    }

    updatePreviousPageUrl(previousButton) {

        // Check that the button exists
        if (previousButton) {

            // Update pagination URL attribute
            const newPreviousPage = previousButton.getAttribute('data-previous-page');
            const oldPreviousButton = this._elem;
            oldPreviousButton.setAttribute('data-previous-page', newPreviousPage);

        // Button doesn't exist, no more items to load
        } else {

            // Remove pagination
            this._paginationWrapper.remove();
        }
    }

    addNewElements(els, url, scroll, direction) {

        // Loop through each new element
        for (const el of els) {

            // Check for preload attributes - update image src's
            if (el.querySelector('[data-preload]')) {
                let preloads = el.querySelectorAll('[data-preload]');
                for (const p of preloads) {
                    p.setAttribute('src', p.getAttribute('data-preload'));
                    p.removeAttribute('data-preload');
                }
            }

            // Add new element to the DOM
            if (direction == 'previous') {
                document.querySelector(this._itemContainerSelector).insertAdjacentElement('afterbegin', el);
            } else {
                document.querySelector(this._itemContainerSelector).appendChild(el);
            }

            // Update button text
            this._elem.innerHTML = this._text;
        }


    }
}

export default registerLegacySalvoLiteComponent({
    component: ShowMore,
    selector: '[data-show-more]', // Required
});
